import { handleWsErrorResponse } from 'core/saga/workers/handleErrorResponse';
import { apply, call, put } from 'redux-saga/effects';
import LarvaWsClientWrapper from 'smartHome/larva/classes/LarvaWsClientWrapper';
import LarvaDeviceController from 'smartHome/larva/classes/LarvaDeviceController';
import { larvaWSActions } from 'smartHome/larva/redux/actions/larvaWSActions';
import handleComponentBroadcast from 'smartHome/larva/utils/handleComponentBroadcast';
import { coreActions } from 'core/redux/actions/coreActions';
import { larvaId } from 'smartHome/larva/utils/makeId';
import { AnyAction } from 'redux';
import TokenService from '../../../../core/config/gql/TokenService';
import WebsocketErrorService from '../../classes/WebsocketErrorService';
import DeviceConnectionGenerator from '../../classes/DeviceConnectionGenerator';

export function* initConnections(action: AnyAction): Generator {
    const { unit, token, shouldBeClosed } = action.payload;
    const tokenService = TokenService.getInstance();
    const errorService = WebsocketErrorService.getInstance();
    const generator = new DeviceConnectionGenerator(tokenService, errorService);

    if (unit && Object.values(unit.devices) && token) {
        for (const deviceId in unit.devices) {
            const deviceObject = unit.devices[deviceId];

            if (!deviceObject) {
                continue;
            }

            try {
                const connection = generator.generate(deviceId, unit.id);
                if (connection.readyState() === WebSocket.CLOSED) {
                    yield call([connection, connection.open]);
                }
                const device = new LarvaDeviceController({
                    id: deviceId,
                    name: deviceObject.name,
                    unitId: deviceObject.unitId,
                });

                yield call(initDeviceConnection, connection, device, shouldBeClosed);
            } catch (error) {
                yield put(
                    coreActions.device.error.component(
                        larvaId(deviceObject.unitId, deviceId),
                        'Device connection failed',
                        error,
                    ),
                );
                errorService.handleError(error);
            }
        }
    }
}

function* initDeviceConnection(client: LarvaWsClientWrapper, device: LarvaDeviceController, shouldBeClosed?: boolean) {
    try {
        yield apply(device, device.connect, [
            client,
            {
                broadCastCallback: handleComponentBroadcast,
            },
            shouldBeClosed,
        ]);
    } catch (error) {
        yield handleWsErrorResponse(error as string);
        if (device.unitId) {
            yield put(
                coreActions.device.error.component(
                    larvaId(device.unitId, device.id),
                    'Failed initDeviceConnection',
                    error,
                ),
            );
        }
        throw new Error('Failed to initDeviceConnection');
    }

    yield put(larvaWSActions.saveConnection(device, client));
}
